import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  h2{
    color: white;
  }
  & ul {
    display: flex;
    list-style: none;

    & li {
      display: flex;
      align-items: center;
      user-select: none;

      & a {
        color: #92968d;

        &:hover {
          color: ${theme.colors.primaryBlue};
          cursor: pointer;
        }
      }

      &.active {
        & a {
          color: ${theme.colors.primaryBlue};
        }

        & svg {
          color: ${theme.colors.primaryBlue};
        }
      }

      & svg {
        margin: 0 0.5rem;
      }
    }
  }
`;
